module.exports = __webpack_public_path__ + "13c69d4c6.png";